import styled from 'styled-components'

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ $padding = '24px 20px' }) => $padding};
  position: relative;
  background-image: linear-gradient(to bottom, #00b8f833 40%, #00b8f800 60%);
  min-height: ${({ $minHeight = '100dvh' }) => $minHeight};
  overflow-y: auto;
`

const LoginContainerInviteAccess = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ $padding = '24px 20px' }) => $padding};
  position: relative;
  min-height: ${({ $minHeight = '100dvh' }) => $minHeight};
  overflow-y: auto;
`

const LoginContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap = '12px' }) => $gap};
`

const LoginContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap = '12px' }) => $gap};
  align-items: ${({ $align = 'center' }) => $align};
`

const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap = '10px' }) => $gap};
`

const LoginFormRemarks = styled.div`
  color: #999999;
  font-size: 12px;
  font-weight: 400;
  padding: 0 16px;
`
const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: auto;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.5);
`

const Modal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ $gap = '10px' }) => $gap};
  padding: ${({ $padding = '24px' }) => $padding};
  // width: 80%;
  width: ${({ $width = '312px' }) => $width};
  min-height: ${({ $height = '212px' }) => $height};
  background-color: ${({ $bg = 'black' }) => $bg};
  border: 1px solid #4b5563;
  border-radius: 28px;
`

export {
  LoginContainer,
  LoginContent,
  LoginContentContainer,
  LoginForm,
  LoginFormRemarks,
  ModalContainer,
  Modal,
  LoginContainerInviteAccess
}
